import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const phrases = ['Tu familia no puede permitirse el seguro equivocado. Angel Insurance se asegura de que tengas el correcto.', 'Hablamos inglés. Hablamos español. Pero sobre todo — hablamos tu idioma.', 'Las grandes compañías quieren tu prima. Nosotros queremos tu confianza.', 'Un seguro no es solo una póliza. Es una promesa a tu familia.', 'La cobertura correcta cuesta menos de lo que crees. La incorrecta lo cuesta todo.'];
export function ImpactPhrases() {
  return <section className="py-14 md:py-20 bg-light-gold/20 overflow-hidden" data-id="element-208">
      <div className="container mx-auto px-4" data-id="element-209">
        <div className="max-w-6xl mx-auto" data-id="element-210">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-211">
            {phrases.map((phrase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-white p-8 rounded-2xl shadow-sm border border-gold/20 relative ${index === 0 ? 'md:col-span-2 lg:col-span-2 bg-navy text-white' : ''} ${index === 4 ? 'md:col-span-2 lg:col-span-3 text-center' : ''}`} data-id="element-212">
                <Quote size={40} className={`absolute top-4 right-4 opacity-10 ${index === 0 ? 'text-white' : 'text-navy'}`} data-id="element-213" />
                <p className={`font-serif text-xl md:text-2xl font-medium leading-relaxed relative z-10 ${index === 0 ? 'text-gold' : 'text-navy'}`} data-id="element-214">
                  "{phrase}"
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}